module.exports = __webpack_public_path__ + "assets/img/bfac-bs.svg";